import { render, staticRenderFns } from "./Trivia11.vue?vue&type=template&id=63c7f328&scoped=true&"
import script from "./Trivia11.vue?vue&type=script&lang=js&"
export * from "./Trivia11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7f328",
  null
  
)

export default component.exports